import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import AudienceIcon from '@public/static/icons/become-author/AudienceIcon'
import CommisionIcon from '@public/static/icons/become-author/CommisionIcon'
import StarsIcon from '@public/static/icons/become-author/StarsIcon'
import { useTranslation } from 'react-i18next'

type Props = {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`
const Top = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
`
const Bottom = styled.div`
  background-color: ${colors.uguPurple};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  left: 0;
`
const TopCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`
const TopCardTitle = styled.div`
  font-family: Sofia Pro;
  font-weight: 700;
  font-size: 1.85rem;
  color: ${colors.uguPurple};
  text-align: center;
`
const TopCardDesc = styled.div`
  text-align: center;
  font-family: Sofia Pro;
  font-size: 17px;
  font-weight: 400;
  letter-spacing: 0em;
  color: #545666da;
  text-align: center;
  max-width: 350px;
`

const BottomWrapper = styled.div`
  width: 100%;
  max-width: 1260px;
  gap: 2rem;
  padding: 0px 40px;
  flex-wrap: wrap;
  justify-content: center;
`
const BottomItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`
const BottomItemTitle = styled.div`
  font-family: Sofia Pro;
  font-size: 1.95rem;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  text-align: center;
  font-weight: 700;
`
const BottomItemLabel = styled.div`
  color: white;
  font-family: Sofia Pro;
  text-align: center;
  font-size: 1.15rem;
`
const ExploreEdugramButtonWrapper = styled.a`
  display: flex;
  width: 18rem;
  justify-content: center;
  border: 1px solid;
  background-color: ${colors.uguBrightPurple};
  margin-top: 1rem;
  font-family: ${fontFamilies.semiBold};
  font-size: 1rem;
  border-radius: 10px;
  padding: 0.75rem;
  color: white;
  :hover {
    cursor: pointer;
  }
`

const ns = 'aboutAuthor'

const KeyBenefits = ({}: Props) => {
  const { t } = useTranslation([ns])

  const stats = [
    {
      label: t('audience', { ns }),
      value: '240M',
    },
    {
      label: t('courseImport', { ns }),
      value: '20 min',
    },
    {
      label: t('languages', { ns }),
      value: '75+',
    },
    {
      label: t('countries', { ns }),
      value: '150+',
    },
    {
      label: t('support', { ns }),
      value: '24/7',
    },
  ]

  return (
    <Wrapper>
      <Top className="max-w-[1070px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5 gap-10 px-2">
          <TopCardWrapper className="col-span-1">
            <CommisionIcon height={'7.2rem'} />
            <TopCardTitle>{t('noCommission', { ns })}</TopCardTitle>
            <TopCardDesc>{t('noCommissionMessage', { ns })}</TopCardDesc>
          </TopCardWrapper>
          <TopCardWrapper className="col-span-1">
            <StarsIcon height={'7.2rem'} />
            <TopCardTitle>{t('beVisible', { ns })}</TopCardTitle>
            <TopCardDesc>{t('beVisibleMessage', { ns })}</TopCardDesc>
          </TopCardWrapper>
          <TopCardWrapper className="col-span-1 sm:col-span-2 lg:col-span-1">
            <AudienceIcon height={'7.2rem'} />
            <TopCardTitle>{t('newAudience', { ns })}</TopCardTitle>
            <TopCardDesc>{t('newAudienceMessage', { ns })}</TopCardDesc>
          </TopCardWrapper>
          <div className="col-span-1 sm:col-span-2 lg:col-span-3 flex justify-center">
            <ExploreEdugramButtonWrapper href="/benefits" target="_blank">
              {t('exploreEdugramBenefits', { ns: 'aboutAuthor' })}
            </ExploreEdugramButtonWrapper>
          </div>
        </div>
      </Top>
      <Bottom className="translate-y-[1020px] sm:translate-y-[745px] lg:translate-y-[420px] md:h-[140px] sm:h-[265px] h-[390px]">
        <BottomWrapper className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5">
          {stats.map((stat, i) => (
            <BottomItemWrapper
              className={
                i === stats.length - 1
                  ? 'col-span-2 sm:col-span-1'
                  : 'col-span-1'
              }
              key={stat.value}
            >
              <BottomItemTitle>{stat.value}</BottomItemTitle>
              <BottomItemLabel>{stat.label}</BottomItemLabel>
            </BottomItemWrapper>
          ))}
        </BottomWrapper>
      </Bottom>
      <div className="md:h-[140px] sm:h-[265px] h-[390px]"></div>
    </Wrapper>
  )
}

export default KeyBenefits
